import { useNavigate } from "react-router-dom"

import SocialMedia from "./SocialMedia"

import romaLogo from "../../images/roma-logo-half.png"

import "../../styles/Banner.css"

function Banner({ user, adminButton }) {
  const navigate = useNavigate()
  
  if (user === null || user === undefined) {
    user = { data: { user: { role: 1 } } } }
    
  return (
    <div className="banner-container" >
      <div className="banner-panel-1">
        {user.data.user.role > 1 ?
          <div className="admin-button-container" onClick={() => navigate("/order/admin")}>
            <button className="admin-button">ADMIN</button>
          </div>
        : null}
        <span className="trans-text">text</span>
      </div>

      <div className="banner-panel-2">
        <a href="/" className="banner-roma-logo-container">
          <img className="roma-logo-banner" src={romaLogo} alt="Roma logo" />
        </a>
      </div>

      <div className="banner-panel-3">
        <SocialMedia />
      </div>
    </div>
  )
}

export default Banner
